var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "docs-table" }, [
    _c("thead", [
      _c(
        "tr",
        { staticClass: "rounded" },
        [
          _c("th", [
            _c(
              "a",
              {
                class: ["sort", { disabled: _vm.disabled }],
                attrs: {
                  role: "button",
                  title: _vm.$t("results.table.sortByDocument").toString(),
                },
                on: {
                  click: function ($event) {
                    return _vm.changeSort(
                      `field:${_vm.specialFields.titleField}`
                    )
                  },
                },
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("results.table.document")) +
                    "\n\t\t\t"
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.metadata, function (meta) {
            return _c("th", { key: meta.id }, [
              _c(
                "a",
                {
                  class: ["sort", { disabled: _vm.disabled }],
                  attrs: {
                    role: "button",
                    title: _vm
                      .$t("results.table.sortBy", {
                        field: _vm.$tMetaDisplayName(meta),
                      })
                      .toString(),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSort(`field:${meta.id}`)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.$tMetaDisplayName(meta)) + " "
                  ),
                  _c("Debug", [_vm._v("(id: " + _vm._s(meta.id) + ")")]),
                ],
                1
              ),
            ])
          }),
          _vm._v(" "),
          _vm.hasHits
            ? _c("th", [
                _c(
                  "a",
                  {
                    class: ["sort", { disabled: _vm.disabled }],
                    attrs: {
                      role: "button",
                      title: _vm.$t("results.table.sortByHits").toString(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeSort(`numhits`)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("results.table.hits")))]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.data, function (rowData, index) {
          return [
            _c("DocRow", {
              key: index,
              attrs: { data: rowData, metadata: _vm.metadata },
            }),
            _vm._v(" "),
            _vm.showHits && rowData.doc.snippets
              ? _c("tr", { key: index + "-hits" }, [
                  _c(
                    "td",
                    { attrs: { colspan: "100" } },
                    [
                      _c("HitsTable", {
                        attrs: {
                          data: _vm.hitRowsForDoc(rowData),
                          mainAnnotation: _vm.mainAnnotation,
                          dir: _vm.dir,
                          html: _vm.html,
                          disabled: true,
                          disableDetails: true,
                        },
                      }),
                      _vm._v(" "),
                      _vm.hiddenHits(rowData)
                        ? _c(
                            "div",
                            { staticClass: "text-muted clearfix col-xs-12" },
                            [
                              _vm._v(
                                "...(" +
                                  _vm._s(_vm.hiddenHits(rowData)) +
                                  " " +
                                  _vm._s(
                                    _vm.$t("results.table.moreHiddenHits")
                                  ) +
                                  ")"
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }